<div *ngFor="let validation of messages[formName].VALIDATIONS[controlName]" style="color:red">
    <div *ngIf="formGroupObj.controls[controlName].hasError(validation.type) && formGroupObj.controls[controlName].dirty">
        {{ validation.message }}
    </div>
</div>
